<div id="scrn">
  <div id="scrn-c">
    <div class="message-heading">
      {{locale.titleText}}
    </div>
    <button class="form-control btn" (click)="goToLogin()">
      {{locale.loginButtonText}}
    </button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/components/account/activation/activation.component.html